import React from 'react';

const LoadingScreen = () => {
  return (
    <div id="loading">
      <div className="loader"></div>
    </div>
  );
};

export default LoadingScreen; 